export default "__VITE_ASSET__CSjCWH45__"